var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('mf-button',{attrs:{"label":"Baixar imagem","text":"","icon":"download","color":"marca-0-l40"},on:{"click":_vm.downloadImage}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }